
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class FreePlanInterceptionDialog extends Vue {
  @Prop({ default: false })
  public value!: boolean;

  @Prop({ default: false })
  public isSubmitting!: boolean;

  get show(): boolean {
    return this.value;
  }

  set show(val: boolean) {
    this.$emit('input', val);
  }

  public handleTrialClick(): void {
    this.$emit('choose-trial');
  }

  public handleFreeClick(): void {
    this.$emit('choose-free');
  }

  public handleDismiss(): void {
    this.$emit('dismiss');
  }
}
